import { CUSTOMERS_TEXT } from '@/texts/catalog/customers';
import { PEOPLE_TEXT } from '@/texts/catalog/people';
import { BILLING_DATA_TEXT } from '@/texts/catalog/billingData';
import { EXPENSES_TEXT } from '@/texts/catalog/expenses';
import { FEES_TEXT } from '@/texts/catalog/fees';
import { INVOICES_TEXT } from '@/texts/catalog/invoices';
import { PAYMENTS_TEXT } from '@/texts/catalog/payments';
import { PAYMENT_RECEIPTS_TEXT } from '@/texts/catalog/paymentReceipts';
import { EXPENSE_RECEIPTS_TEXT } from '@/texts/catalog/expenseReceipts';
import { FLAT_RATES_TEXT } from '@/texts/catalog/flatRates';
import { SALES_TEXT } from '@/texts/catalog/sales';
import { GENERAL_TEXT } from '@/texts/catalog/general';
import { RECENT_ACTIVITY_TEXT } from '@/texts/catalog/recentActivity';
import { DOCUMENTS_TEXT } from '@/texts/catalog/documents';
import { SUPPLIERS_TEXT } from '@/texts/catalog/suppliers';
import { REPORTS_TEXT } from '@/texts/catalog/reports';
import { SEND_EMAIL_TEXT } from '@/texts/catalog/sendEmail';
import { SIMPLE_NOTES_TEXT } from '@/texts/catalog/simpleNotes';
import { FINANCIAL_TEXT } from '@/texts/catalog/financial';

const DOMAIN_TEXTS = Object.freeze({
	customers: CUSTOMERS_TEXT,
	people: PEOPLE_TEXT,
	billingData: BILLING_DATA_TEXT,
	expenses: EXPENSES_TEXT,
	fees: FEES_TEXT,
	invoices: INVOICES_TEXT,
	payments: PAYMENTS_TEXT,
	paymentReceipts: PAYMENT_RECEIPTS_TEXT,
	expenseReceipts: EXPENSE_RECEIPTS_TEXT,
	flatRates: FLAT_RATES_TEXT,
	sales: SALES_TEXT,
	general: GENERAL_TEXT,
	recentActivity: RECENT_ACTIVITY_TEXT,
	documents: DOCUMENTS_TEXT,
	suppliers: SUPPLIERS_TEXT,
	reports: REPORTS_TEXT,
	sendEmail: SEND_EMAIL_TEXT,
	simpleNotes: SIMPLE_NOTES_TEXT,
	financial: FINANCIAL_TEXT,
});

const isPlainObject = (value) => value !== null && typeof value === 'object' && !Array.isArray(value);

export const resolveDomainText = (domain, path, fallback = '') => {
	const catalog = DOMAIN_TEXTS[String(domain || '').trim()];
	if (!isPlainObject(catalog)) {
		return fallback;
	}

	const keys = String(path || '')
		.split('.')
		.map((item) => item.trim())
		.filter(Boolean);

	if (keys.length === 0) {
		return fallback;
	}

	let current = catalog;

	for (let index = 0; index < keys.length; index += 1) {
		const key = keys[index];
		if (!isPlainObject(current) && index < keys.length - 1) {
			return fallback;
		}

		current = current?.[key];

		if (current === undefined) {
			return fallback;
		}
	}

	return current;
};

export const useDomainText = (domain) => {
	const normalizedDomain = String(domain || '').trim();
	const catalog = DOMAIN_TEXTS[normalizedDomain] || {};

	return {
		catalog,
		t: (path, fallback = '') => resolveDomainText(normalizedDomain, path, fallback),
	};
};
